<ng-container *ngIf="isTnRequest">
    <app-request-action-toolbar-button
        *appEnableForRoles="copyRoles"
        buttonLabel="Copy Request"
        (onButtonClicked)="cloneRequest()">
    </app-request-action-toolbar-button>
</ng-container>

<app-request-action-toolbar-button
    *appEnableForRoles="reAssignRoles"
    [visibilityStatuses]="reAssignButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Re-assign"
    (onButtonClicked)="showReAssignmentModal()">
</app-request-action-toolbar-button>

<ng-container *ngIf="isDonorNeeded">
  <app-request-action-toolbar-button
      *appEnableForRoles="donorRequestRoles"
      buttonLabel="Create Donor Request"
      (onButtonClicked)="createDonorRequest()">
  </app-request-action-toolbar-button>
</ng-container>

<app-request-action-toolbar-button
    *appEnableForRoles="rejectRoles"
    [visibilityStatuses]="rejectButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Reject"
    (onButtonClicked)="showRejectionModal()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="assignRoles"
    [visibilityStatuses]="assignButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Assign"
    (onButtonClicked)="showAssignmentModal()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="planRoles"
    [visibilityStatuses]="planButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Plan"
    (onButtonClicked)="showPlanningModal()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="reviewRoles"
    [visibilityStatuses]="reviewButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Review"
    (onButtonClicked)="showReviewModal()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="createExperimentRoles"
    [visibilityStatuses]="createExperimentButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Create Experiment"
    (onButtonClicked)="showExperimentCreationModal()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="printPlantingCardRoles"
    [visibilityStatuses]="printPlantingCardButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Print Planting Card"
    (onButtonClicked)="printPlantingCard()">
</app-request-action-toolbar-button>

<app-request-action-toolbar-button
    *appEnableForRoles="exportEuidRoles"
    [visibilityStatuses]="exportButtonStatuses"
    [requestStatus]="request.statusId"
    buttonLabel="Export EUIDs"
    (onButtonClicked)="exportEuids()">
</app-request-action-toolbar-button>

<ng-container *ngIf="isTnRequest">
    <app-request-action-toolbar-button
        *appEnableForRoles="cancelRoles"
        [visibilityStatuses]="cancelButtonStatuses"
        [requestStatus]="request.statusId"
        buttonLabel="Cancel"
        (onButtonClicked)="cancelRequest()">
    </app-request-action-toolbar-button>
</ng-container>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-action-toolbar/request-action-toolbar.component.html